import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { Column, Button } from "../../components";
import { getAllLanguageApi } from "../../Services/apiCalls";
import {
  setNotificationAction,
  toggleLoadingAction,
} from "../../Redux/actions";
import {
  getAllSectorsApi,
  saveSectorApi,
  getAllIndustriesApi,
} from "./apiCalls";
import "../EmailTemplates/email.scss";
import "./sectors.scss";

// Sector industry tiers (SectorIndustryTier on the API)
const tiers = [
  { value: 1, label: "Core" },
  { value: 2, label: "Supporting" },
];

const emptySector = {
  SectorId: 0,
  SectorKey: "",
  SectorValueEn: "",
  IsActive: true,
  Industries: [],
  Translations: [],
};

class Sectors extends Component {
  state = {
    isCollapsed1: false,
    isCollapsed2: true,
    sectors: [],
    industries: [],
    languages: [],
    selectedSector: emptySector,
    invalid: {},
  };

  componentDidMount = () => {
    this.getSectors();
    getAllIndustriesApi().then((res) =>
      this.setState({
        industries: (res?.items || []).map((i) => ({
          value: i.IndustryId,
          label: i.IndustryValueEn || i.IndustryValue,
        })),
      })
    );
    getAllLanguageApi().then((res) =>
      this.setState({
        languages: (res?.items || []).map((l) => ({
          value: l.LanguageId,
          label: l.LanguageValue,
        })),
      })
    );
  };

  notify = (message, status) =>
    this.props.setNotificationAction({ message, status });

  getSectors = (selectSectorId) => {
    this.props.toggleLoadingAction(true);
    getAllSectorsApi().then((res) => {
      const sectors = res?.items || [];
      const selected = sectors.find((s) => s.SectorId === selectSectorId);
      this.setState((st) => ({
        sectors,
        selectedSector: selected || st.selectedSector,
      }));
      this.props.toggleLoadingAction(false);
    });
  };

  updateSector = (changes) =>
    this.setState((st) => ({
      selectedSector: { ...st.selectedSector, ...changes },
      invalid: {},
    }));

  updateIndustry = (industryId, changes) =>
    this.updateSector({
      Industries: this.state.selectedSector.Industries.map((i) =>
        i.IndustryId === industryId ? { ...i, ...changes } : i
      ),
    });

  addIndustry = (option) => {
    if (!option) return;
    this.updateSector({
      Industries: [
        ...this.state.selectedSector.Industries,
        {
          IndustryId: option.value,
          IndustryValue: option.label,
          Tier: 1,
          IsActive: true,
        },
      ],
    });
  };

  removeIndustry = (industryId) =>
    this.updateSector({
      Industries: this.state.selectedSector.Industries.filter(
        (i) => i.IndustryId !== industryId
      ),
    });

  updateTranslation = (languageId, value) => {
    const others = this.state.selectedSector.Translations.filter(
      (t) => t.LanguageId !== languageId
    );
    this.updateSector({
      Translations: [...others, { LanguageId: languageId, SectorValue: value }],
    });
  };

  addTranslation = (option) => {
    if (!option) return;
    this.updateTranslation(option.value, "");
  };

  removeTranslation = (languageId) =>
    this.updateSector({
      Translations: this.state.selectedSector.Translations.filter(
        (t) => t.LanguageId !== languageId
      ),
    });

  handleSave = () => {
    const { selectedSector } = this.state;
    const invalid = {
      SectorKey: !/^[a-z0-9-]{1,50}$/.test(
        (selectedSector.SectorKey || "").trim().toLowerCase()
      ),
      SectorValueEn: !(selectedSector.SectorValueEn || "").trim(),
    };
    if (invalid.SectorKey || invalid.SectorValueEn) {
      this.setState({ invalid });
      this.notify(
        "Key (letters, digits and '-') and English name are required",
        "error"
      );
      return;
    }
    this.props.toggleLoadingAction(true);
    saveSectorApi(selectedSector).then((res) => {
      this.props.toggleLoadingAction(false);
      if (res?.success) {
        this.notify(res.message || "Sector saved", "success");
        this.getSectors(res.items?.SectorId);
      } else {
        this.notify(
          res?.message ||
            res?.response?.data?.message ||
            "Something went wrong try again",
          "error"
        );
      }
    });
  };

  renderIndustries() {
    const { selectedSector, industries } = this.state;
    const mappedIds = selectedSector.Industries.map((i) => i.IndustryId);
    return (
      <div className="input-field">
        <h6>{"Industries"}</h6>
        <p className="sector-hint">
          {
            "Only active industries are used. Roles, skills, certifications and educations of these industries are shown to users of this sector."
          }
        </p>
        <table className="sector-table">
          <thead>
            <tr>
              <th>{"Industry"}</th>
              <th>{"Tier"}</th>
              <th>{"Active"}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {selectedSector.Industries.map((industry) => (
              <tr key={industry.IndustryId}>
                <td>{industry.IndustryValue}</td>
                <td className="sector-tier">
                  <Select
                    value={industry.Tier}
                    options={tiers}
                    clearable={false}
                    searchable={false}
                    onChange={(option) =>
                      this.updateIndustry(industry.IndustryId, {
                        Tier: option.value,
                      })
                    }
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={industry.IsActive}
                    onChange={(e) =>
                      this.updateIndustry(industry.IndustryId, {
                        IsActive: e.target.checked,
                      })
                    }
                  />
                </td>
                <td>
                  <button
                    className="sector-remove"
                    onClick={() => this.removeIndustry(industry.IndustryId)}
                  >
                    {"Remove"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Select
          placeholder={"Add industry"}
          value=""
          options={industries.filter((i) => !mappedIds.includes(i.value))}
          onChange={this.addIndustry}
        />
      </div>
    );
  }

  renderTranslations() {
    const { selectedSector, languages } = this.state;
    const languageName = (id) =>
      (languages.find((l) => l.value === id) || {}).label || id;
    const translatedIds = selectedSector.Translations.map((t) => t.LanguageId);
    return (
      <div className="input-field">
        <h6>{"Translations"}</h6>
        <table className="sector-table">
          <tbody>
            {[...selectedSector.Translations]
              .sort((a, b) => a.LanguageId - b.LanguageId)
              .map((translation) => (
                <tr key={translation.LanguageId}>
                  <td>{languageName(translation.LanguageId)}</td>
                  <td>
                    <input
                      type="text"
                      value={translation.SectorValue || ""}
                      onChange={(e) =>
                        this.updateTranslation(
                          translation.LanguageId,
                          e.target.value
                        )
                      }
                    />
                  </td>
                  <td>
                    <button
                      className="sector-remove"
                      onClick={() =>
                        this.removeTranslation(translation.LanguageId)
                      }
                    >
                      {"Remove"}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <Select
          placeholder={"Add language"}
          value=""
          options={languages.filter((l) => !translatedIds.includes(l.value))}
          onChange={this.addTranslation}
        />
      </div>
    );
  }

  render() {
    const { labels } = this.props;
    const {
      isCollapsed1,
      isCollapsed2,
      sectors,
      selectedSector,
      invalid,
    } = this.state;

    return (
      <div className="email-templates-module sectors-module columns-wrapper">
        <Column collapse={isCollapsed1} className="col-1">
          <Column.Collapsed
            text={"Sectors"}
            onClick={() => this.setState({ isCollapsed1: false })}
            tooltipButton={labels.ADMIN_EXPAND}
            tooltipHelp={labels.ADMIN_EXPAND_BTN}
            tooltipPlace="left"
            testId={"column-1-expand"}
          />
          <Column.Head>
            <div className="heading">
              <p>{"Sectors"}</p>
            </div>
            <Button
              className="button-primary AddBtn"
              testId={"add-sector-btn"}
              tooltipButton={"Add sector"}
              tooltipHelp={labels.ADMIN_COLLAPSE_HELP}
              onClick={() =>
                this.setState({
                  selectedSector: emptySector,
                  invalid: {},
                  isCollapsed2: false,
                })
              }
            />
            <Button
              onClick={() => this.setState({ isCollapsed1: true })}
              className="collapseBtn"
              tooltipButton={labels.ADMIN_COLLAPSE}
              tooltipHelp={labels.ADMIN_COLLAPSE_HELP}
              tooltipPlace="left"
              testId={"column-1-collapse"}
            />
          </Column.Head>
          <Column.Body>
            <div className="first-column admin-save-form">
              {sectors.length > 0 ? (
                <div className="list-wrapper">
                  {sectors.map((sector) => (
                    <div
                      className={`list-item ${
                        sector.SectorId === selectedSector.SectorId
                          ? "active"
                          : ""
                      }`}
                      key={sector.SectorId}
                      onClick={() =>
                        this.setState({
                          selectedSector: sector,
                          invalid: {},
                          isCollapsed2: false,
                        })
                      }
                    >
                      <div className="list_item_title">
                        <p style={{ fontWeight: "600" }}>
                          {sector.SectorValueEn}
                          {!sector.IsActive && " (inactive)"}
                        </p>
                        <p style={{ marginTop: "4px", fontSize: "12px" }}>
                          {`sector=${sector.SectorKey} · ${
                            sector.Industries.filter((i) => i.IsActive).length
                          } active / ${sector.Industries.length} industries`}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no-item-label">
                  <label>{labels.ADMIN_NO_ITEM_TO_DISPLAY}</label>
                </div>
              )}
            </div>
          </Column.Body>
        </Column>
        <Column collapse={isCollapsed2} className="col-1">
          <Column.Collapsed
            text={"Sector Detail"}
            onClick={() => this.setState({ isCollapsed2: false })}
            tooltipButton={labels.ADMIN_EXPAND}
            tooltipHelp={labels.ADMIN_EXPAND_BTN}
            tooltipPlace="left"
            testId={"column-2-expand"}
          />
          <Column.Head>
            <div className="heading">
              <p>{"Sector Detail"}</p>
            </div>
            <Button
              onClick={() => this.setState({ isCollapsed2: true })}
              className="collapseBtn"
              tooltipButton={labels.ADMIN_COLLAPSE}
              tooltipHelp={labels.ADMIN_COLLAPSE_HELP}
              tooltipPlace="left"
              testId={"column-2-collapse"}
            />
          </Column.Head>
          <Column.Body>
            <div className="admin-save-form" style={{ padding: "12px" }}>
              <div
                className={`input-field ${invalid.SectorKey ? "invalid" : ""}`}
              >
                <h6>{"Key (signup?sector=...)"}</h6>
                <div>
                  <input
                    type="text"
                    value={selectedSector.SectorKey || ""}
                    onChange={(e) =>
                      this.updateSector({ SectorKey: e.target.value })
                    }
                    test-data-id={"input-sector-key"}
                  />
                </div>
              </div>
              <div
                className={`input-field ${
                  invalid.SectorValueEn ? "invalid" : ""
                }`}
              >
                <h6>{"Name (English)"}</h6>
                <div>
                  <input
                    type="text"
                    value={selectedSector.SectorValueEn || ""}
                    onChange={(e) =>
                      this.updateSector({ SectorValueEn: e.target.value })
                    }
                    test-data-id={"input-sector-name"}
                  />
                </div>
              </div>
              <div className="input-field">
                <h6>{"Active"}</h6>
                <div className={"list-checkbox"}>
                  <input
                    type="checkbox"
                    checked={selectedSector.IsActive}
                    onChange={(e) =>
                      this.updateSector({ IsActive: e.target.checked })
                    }
                  />
                  <span>{"Active"}</span>
                </div>
              </div>
              {this.renderTranslations()}
              {this.renderIndustries()}
            </div>
            <div style={{ textAlign: "center" }}>
              <button className="btn btn-login " onClick={this.handleSave}>
                {selectedSector.SectorId ? "Update Sector" : "Add Sector"}
              </button>
            </div>
          </Column.Body>
        </Column>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    labels: state.labels,
  };
}

const actions = {
  setNotificationAction,
  toggleLoadingAction,
};

export default connect(mapStateToProps, actions)(withRouter(Sectors));
